/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  /* Mobile menu: resize drawer to fit each submenu level */
  var BUFFER = 12; // breathing room under the last link, in px

  function bottomOf(container, menuTop) {
    var max = 0;
    Array.prototype.forEach.call(container.children, function (el) {
      if (getComputedStyle(el).position === 'absolute') return;
      var b = el.getBoundingClientRect().bottom - menuTop;
      if (b > max) max = b;
    });
    return max;
  }

  function panelHeight(menu, panel) {
    var menuTop = menu.getBoundingClientRect().top;
    var links = panel.querySelector(':scope > .sliderow__links');
    var back = panel.querySelector(':scope > .sliderow--back');
    var h = Math.max(
      links ? bottomOf(links, menuTop) : 0,
      back ? back.getBoundingClientRect().bottom - menuTop : 0
    );
    return h + BUFFER;
  }

  function topHeight(menu) {
    var main = menu.querySelector('.drawer__main-menu');
    return main ? bottomOf(main, menu.getBoundingClientRect().top) + BUFFER : menu.offsetHeight;
  }

  function animateTo(menu, target) {
    if (!menu.style.minHeight) {
      menu.style.minHeight = menu.offsetHeight + 'px';
      menu.offsetHeight;
    }
    requestAnimationFrame(function () {
      menu.style.minHeight = target + 'px';
    });
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-sliderule-open]');
    var closeBtn = e.target.closest('[data-sliderule-close]');
    var drawerClose = e.target.closest('[data-drawer-close], [data-drawer-underlay]');

    if (drawerClose) {
      document.querySelectorAll('.drawer__menu').forEach(function (m) {
        m.style.transition = 'none';
        m.style.minHeight = '';
        m.offsetHeight;
        m.style.transition = '';
      });
      return;
    }

    var menu = (openBtn || closeBtn) && (openBtn || closeBtn).closest('.drawer__menu');
    if (!menu) return;

    if (closeBtn) {
      var closing = closeBtn.closest('mobile-sliderule');
      var parentPanel = closing && closing.parentElement.closest('.sliderule__panel');
      animateTo(menu, parentPanel ? panelHeight(menu, parentPanel) : topHeight(menu));
      return;
    }

    var rule = document.getElementById(openBtn.getAttribute('data-sliderule-open'));
    var panel = rule && rule.querySelector('.sliderule__panel');
    if (panel) animateTo(menu, panelHeight(menu, panel));
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();